import { Heading, Text, Button, Dialog, IconButton } from 'frosted-ui';
import { XMark16, Star16, Heart16 } from '@frosted-ui/icons';
import { api } from '../services/api';

interface ReviewPromptModalProps {
  companyId: string;
  onClose: () => void;
}

// Paywall Lab's app ID in Whop's app store
const WHOP_APP_ID = 'app_LphbdQi4FOb58D';

function getWhopReviewUrl(companyId: string): string {
  return `https://whop.com/dashboard/${companyId}/app-store/apps/${WHOP_APP_ID}/`;
}

export default function ReviewPromptModal({ companyId, onClose }: ReviewPromptModalProps) {
  async function handleLeaveReview() {
    const reviewUrl = getWhopReviewUrl(companyId);
    try {
      // Record that user clicked to leave review
      await api.recordReviewPromptClicked(companyId);
      // Open Whop app page in new tab
      window.open(reviewUrl, '_blank');
      onClose();
    } catch (err) {
      console.error('Failed to record review click:', err);
      // Still open the review page even if tracking fails
      window.open(reviewUrl, '_blank');
      onClose();
    }
  }

  async function handleMaybeLater() {
    try {
      // Record dismissal to trigger freeze period
      await api.recordReviewPromptDismiss(companyId);
    } catch (err) {
      console.error('Failed to record dismissal:', err);
    }
    onClose();
  }

  return (
    <Dialog.Root open onOpenChange={(open: boolean) => !open && handleMaybeLater()}>
      <Dialog.Content style={{ maxWidth: 420 }}>
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginBottom: 'var(--space-4)',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 'var(--radius-3)',
              backgroundColor: 'var(--accent-a3)',
            }}
          >
            <Star16 style={{ color: 'var(--accent-9)', width: 24, height: 24 }} />
          </div>
          <IconButton
            variant="ghost"
            color="gray"
            size="1"
            onClick={handleMaybeLater}
            aria-label="Close"
          >
            <XMark16 />
          </IconButton>
        </div>

        {/* Content */}
        <Heading size="5" style={{ marginBottom: 'var(--space-2)' }}>
          People are finding your test
        </Heading>
        <Text color="gray" size="3" style={{ display: 'block', marginBottom: 'var(--space-5)' }}>
          Enjoying Paywall Lab? A quick review helps other creators discover us and improves the
          product for everyone.
        </Text>

        {/* Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
          <Button variant="solid" size="3" onClick={handleLeaveReview} style={{ width: '100%' }}>
            <Heart16 />
            Leave a Review
          </Button>
          <Button
            variant="soft"
            color="gray"
            size="3"
            onClick={handleMaybeLater}
            style={{ width: '100%' }}
          >
            Maybe Later
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}
